<div class="modal idle-warning">
  <h1 id="idle-warning-title" mat-dialog-title>Warning</h1>
  <div mat-dialog-content>
    <p id="idle-warning-message">Your session will expire in less than <strong>{{countdown}}</strong> second(s).
      <br><br> Please press any key or move mouse to resume current session.</p>
  </div>
</div>
